import { Tooltip } from "@/atoms"

import type { ActionOptionLabelProps } from "./ActionsSectionForm.types"

export const ActionOptionLabel = (props: ActionOptionLabelProps) => {
  const { displayName, disabled, disabledReason } = props

  if (!disabled || !disabledReason) return displayName

  return (
    <Tooltip title={disabledReason} placement="right">
      <span>{displayName}</span>
    </Tooltip>
  )
}
